// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2siuL","subheader":"ReorderModal_subheader__1uClG","listWrap":"ReorderModal_listWrap__3qvAJ"};